import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import i18n from "../../../../../constants/i18n";
import {
  ALLOWED_AGES,
  ALLOWED_HEIGHTS,
  ALLOWED_WEIGHTS,
  KHATTABAT_MATCHING_FIELD_SIZE
} from "../../../../../constants/user-profile";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import FilterSelect from "./FilterSelect";

const KhattabatMatchingRangeFilters = withLiteObserverAndTheme(() => {
  return (
    <>
      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <Stack direction="row" spacing={1}>
          <FilterSelect
            label={i18n.get("MIN_AGE")}
            options={ALLOWED_AGES}
            value={getKhattabatMatchingStore().minMatchAgeFilter.get()}
            onChange={getKhattabatMatchingStore().setMinMatchAgeFilter}
          />
          <FilterSelect
            label={i18n.get("MAX_AGE")}
            options={ALLOWED_AGES}
            value={getKhattabatMatchingStore().maxMatchAgeFilter.get()}
            onChange={getKhattabatMatchingStore().setMaxMatchAgeFilter}
          />
        </Stack>
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <Stack direction="row" spacing={1}>
          <FilterSelect
            label={i18n.get("MIN_WEIGHT")}
            options={ALLOWED_WEIGHTS}
            value={getKhattabatMatchingStore().minMatchWeightFilter.get()}
            onChange={getKhattabatMatchingStore().setMinMatchWeightFilter}
          />
          <FilterSelect
            label={i18n.get("MAX_WEIGHT")}
            options={ALLOWED_WEIGHTS}
            value={getKhattabatMatchingStore().maxMatchWeightFilter.get()}
            onChange={getKhattabatMatchingStore().setMaxMatchWeightFilter}
          />
        </Stack>
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <Stack direction="row" spacing={1}>
          <FilterSelect
            label={i18n.get("MIN_HEIGHT")}
            options={ALLOWED_HEIGHTS}
            value={getKhattabatMatchingStore().minMatchHeightFilter.get()}
            onChange={getKhattabatMatchingStore().setMinMatchHeightFilter}
          />
          <FilterSelect
            label={i18n.get("MAX_HEIGHT")}
            options={ALLOWED_HEIGHTS}
            value={getKhattabatMatchingStore().maxMatchHeightFilter.get()}
            onChange={getKhattabatMatchingStore().setMaxMatchHeightFilter}
          />
        </Stack>
      </Grid>
    </>
  );
});

export default KhattabatMatchingRangeFilters;
